export const GlobalConfig = "GlobalConfig";
